//@ts-check
import React, { useEffect } from 'react';
import PageToolBar from '../../ToolBar';
import PageCommon from '../../Common';
import { Grid, Typography } from '@material-ui/core';
import { DataGrid, Modals, Button, DataAction, DataFilter } from 'ecrion-components';
import Formatter from '../../../formatter';
import { Page } from 'ecrion-components';

var Tracking = function Tracking(_ref) {
  var history = _ref.history,
      onClose = _ref.onClose;
  useEffect(function () {
    document.title = 'Settings � Email Tracking � Ecrion';
  }, []);
  var icon = null;

  if (history || onClose) {
    icon = {
      type: 'close',
      onClick: undefined
    };

    if (history) {
      icon.onClick = function () {
        return history && history.return && history.return('/settings');
      };
    } else if (onClose) {
      icon.onClick = onClose;
    }
  }

  return React.createElement(React.Fragment, null, React.createElement(Page.ToolBar, {
    icon: icon,
    leftChildren: "Tracking",
    color: "navbar"
  }), React.createElement(Page.Common, null, React.createElement(Typography, {
    variant: "h6"
  }, "Tracking"), React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(DataFilter, {
    history: history,
    location: location,
    searchIn: "Domain",
    variant: "h6",
    options: [{
      label: 'All',
      value: null
    }]
  })), React.createElement(Grid, {
    item: true,
    xs: true
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      Modals.open({
        type: Modals.TYPES.TRACKER_EMAIL_SETTINGS,
        props: {
          formFieldType: 'Domain',
          formField: {
            label: 'Domain'
          },
          submitLabel: 'Save',
          submittingLabel: 'Saving...',
          onSubmit: function onSubmit(data) {
            return DataAction.item({
              dataType: 'tracking'
            }).create({
              Name: data
            });
          }
        }
      });
    }
  }, "New")), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(DataGrid, {
    id: "email-tracking",
    dataType: "tracking",
    viewProps: {
      hideModeSwitcher: true
    },
    dataProps: {
      defaultDomain: window.location.host
    },
    styles: {
      elevation: 0
    }
  })))));
};

Tracking.defaultProps = {
  onClose: null
};
export default Tracking;